import { useQuery } from '@tanstack/react-query';

import { getCustomSources } from '~/views/alfred/research/services/conversations-service';

export const QUERY_KEY_CUSTOM_SOURCES = 'QUERY_KEY_CUSTOM_SOURCES';

export const useCustomSources = (enabled = true) =>
  useQuery({
    queryKey: [QUERY_KEY_CUSTOM_SOURCES],
    queryFn: () => getCustomSources(),
    enabled,
  });
